import { Segment } from "./Segment";
import Cargo from "./Cargo";
import { TTimeLineAttribute } from "../types/TTimeLineAttribute";
import { DeviceConfig } from "../services/DeviceConfigService";
import { IAnyObject } from "../interfaces";

export class BaseShipment {
	public id: string;
	public masterTrackingNo: string;
	public shipperReferenceNo: string;
	public name: string;
	public segments: Segment[];
	public cargoes: Cargo[];

	public status: string;
	public exceptionCode: number;
	public promptness: string;
	public releasedDate: number;
	public returnedDate: number;
	public lessee: string;
	public flight: string;
	public awb: string;
	public company: string;
	public leg: string;

	public constructor(data: IAnyObject) {
		if (!data) {
			return;
		}

		const shipmentData = (data.data as IAnyObject) || data;
		if (shipmentData) {
			this.id = shipmentData.shipmentId as string;
			this.name = shipmentData.name as string;
			this.masterTrackingNo = shipmentData.masterTrackingNo as string;
			this.shipperReferenceNo = shipmentData.ShipperReferenceNo as string;
			this.status = shipmentData.status as string;
			this.exceptionCode = shipmentData.exceptionCode as number;
			this.promptness = shipmentData.promptness as string;
			this.lessee = shipmentData.lesseeName as string;
			this.flight = shipmentData.flight as string;
			this.awb = shipmentData.awb as string;
			this.company = shipmentData.company as string;
			this.leg = shipmentData.leg as string;
		}

		if (data.segments) {
			this.segments = (data.segments as IAnyObject[]).map(_ => new Segment(_));
		}

		if (data.cargoes) {
			this.cargoes = (data.cargoes as IAnyObject[]).map(_ => new Cargo(_));
		}
	}

	public toString(): string {
		return "";
	}

	public static parse(serialized: string): BaseShipment {
		return new BaseShipment(JSON.parse(serialized));
	}

	public static stringify(instance: BaseShipment): string {
		return JSON.stringify(instance);
	}

	public getTimeLineAttributesConfig(): TTimeLineAttribute {
		return DeviceConfig.getTimeLineConfig();
	}
}
